/** 储存方式 */
export enum STORAGE_TYPE_EMUN {
  'homoeothermy' = 1,
  'refrigeration',
}
export const STORAGE_TYPE = [
  {
    value: STORAGE_TYPE_EMUN['homoeothermy'],
    label: '常温',
  },
  {
    value: STORAGE_TYPE_EMUN['refrigeration'],
    label: '冷藏',
  },
]
